import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import JobsReTranscodeForm from "../components/job/JobsRetranscodeForm";
import PageContainer from "../components/shared/PageContainer";
import { useConfig } from "../contexts/ConfigContext";
import { JobOperation, Profile, Profiles } from "../services/api";
import { OperationType } from "../services/api/JobOperation";

function JobReTranscode() {
  const location = useLocation();
  const navigate = useNavigate();
  const { config } = useConfig();
  const [availableProfiles, setAvailableProfiles] = useState<Profile[]>([]);
  const { from, ids } = location.state;

  const [jobTranscodeOperation, setJobTranscodeOperation] = React.useState<JobOperation>(
    new JobOperation({
      ids: ids,
      accounts: config.registerAccounts,
      primary_regions: config.regions.primary_regions,
      secondary_regions: config.regions.secondary_regions,
      overwrite: true,
      useDefaultProfiles: false,
      profiles: [],
      operation: OperationType.TRANSCODE,
    }),
  );

  const handleTranscode = () => {
    jobTranscodeOperation.create().then(() => navigate(from));
  };

  useEffect(() => {
    Profiles.list().then(setAvailableProfiles);
  }, []);

  return (
    <PageContainer>
      <JobsReTranscodeForm
        jobTranscodeOperation={jobTranscodeOperation}
        setJobTranscodeOperation={setJobTranscodeOperation}
        onTranscode={handleTranscode}
        onCancel={() => navigate(from)}
        availableProfiles={availableProfiles!}
      />
    </PageContainer>
  );
}

export default JobReTranscode;
